import { render, staticRenderFns } from "./PagedListPlaylistsNoHighlights.vue?vue&type=template&id=1a46412d&"
import script from "./PagedListPlaylistsNoHighlights.vue?vue&type=script&lang=js&"
export * from "./PagedListPlaylistsNoHighlights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports